// 生年月日は西暦 年-月-日 だけを送る (全角と / . 年月日 は直す。数字 8 桁はそのまま打てる)。
// 読めない形は送らない。
export const normalizeBirthDate = (value: string): string | null => {
  const half = value
    .trim()
    .replace(/[０-９]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0))
    .replace(/[年月./]/g, '-')
    .replace(/日$/, '')
    .replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3')
  const m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(half)
  if (!m) return null
  const [, y, mo, d] = m
  return `${y}-${mo.padStart(2, '0')}-${d.padStart(2, '0')}`
}
